import type { GetSuggestionsResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { useGetDesignTypes } from "@/features/request/edit/hooks/useGetDesignTypes";
import { isTeamUser } from "@/features/requests/utils/roleUtils.ts";
import { useGetRequest } from "@/hooks/useGetRequest.tsx";
import { useUser } from "@/hooks/useUser.tsx";
import apiClient from "@/lib/api/client";

export function useSuggestions() {
  const { data: request, isSuccess } = useGetRequest();
  const { data: user } = useUser();
  const { data } = useGetDesignTypes();
  const designType = data?.subcategories
    ?.flatMap((category) => category.designTypes)
    .find((type) => type.id === request?.designTypeId);

  const query = useQuery<GetSuggestionsResponse>({
    enabled: isSuccess && !!request?.id && !isTeamUser(user?.user.roleName),
    queryFn: () => {
      let url = apiClient.url("/requests/suggestions");

      if (request) {
        url = url.query({ requestId: request?.id });
      }

      return url.get().json();
    },
    queryKey: ["suggestions", request?.id],
  });

  return {
    ...query,
    suggestions: query.data?.suggestions || [],
    title: `${designType?.name} completed!`,
  };
}
